import React from 'react';
import cx from 'classnames';

import TextActionAccordion from '../TextActionAccordion';
import ActionStateBannerStyleButton, {
  ActionState,
  ActionStateBannerStyleButtonProps,
} from '../ActionStateBannerStyleButton';

import styles from './index.module.scss';

export interface BannerStyleButtonActionAccordionProps {
  activeStateTagText?: string;
  number: string;
  title: string;
  subtitle?: string;
  text?: string;
  isOpenByDefault?: boolean;
  leftButtonText?: string;
  buttonOnClick?: () => void;
  isButtonLoading?: boolean;
  leftButtonError?: object;
  completed: boolean;
  rightButtonText?: string;
  rightButtonUrl?: string;
  contentLinkText?: string;
  contentLinkUrl?: string;
  actionStateBannerStyleButton: ActionStateBannerStyleButtonProps;
  bannerTitle: string;
  bannerSubtitle?: string;
  bannerImageUrl?: string;
  bannerImageAlt?: string;
  bannerUrl: string;
  bannerActionState?: ActionState;
  className?: string;
  bannerStyleButtonOnClick?: () => void;
}

const BannerStyleButtonActionAccordion: React.FC<
  BannerStyleButtonActionAccordionProps
> = ({
  activeStateTagText,
  number,
  title,
  subtitle,
  text,
  isOpenByDefault,
  leftButtonText,
  buttonOnClick,
  isButtonLoading,
  leftButtonError,
  completed,
  rightButtonText,
  rightButtonUrl,
  contentLinkText,
  contentLinkUrl,
  bannerTitle,
  bannerSubtitle,
  bannerImageUrl,
  bannerImageAlt,
  bannerUrl,
  bannerActionState,
  className,
  bannerStyleButtonOnClick,
}) => {
  return (
    <div className={cx(styles.wrapper, className)}>
      <TextActionAccordion
        title={title}
        subtitle={subtitle}
        isOpenByDefault={isOpenByDefault}
        text={text}
        number={number}
        activeStateTagText={activeStateTagText}
        leftButtonText={leftButtonText}
        buttonOnClick={buttonOnClick}
        isButtonLoading={isButtonLoading}
        leftButtonError={leftButtonError}
        completed={completed}
        rightButtonText={rightButtonText}
        rightButtonUrl={rightButtonUrl}
        contentLinkText={contentLinkText}
        contentLinkUrl={contentLinkUrl}
      >
        <div className={styles.bannerStyleButton}>
          <ActionStateBannerStyleButton
            title={bannerTitle}
            subtitle={bannerSubtitle}
            imageUrl={bannerImageUrl}
            imageAlt={bannerImageAlt}
            url={bannerUrl}
            actionState={bannerActionState}
            bannerStyleButtonOnClick={bannerStyleButtonOnClick}
          />
        </div>
      </TextActionAccordion>
    </div>
  );
};

export default BannerStyleButtonActionAccordion;
